import { render, staticRenderFns } from "./PermissionView.vue?vue&type=template&id=109e39a2&"
import script from "./PermissionView.vue?vue&type=script&lang=js&"
export * from "./PermissionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports